import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [


  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },

  {
    path: 'dash',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },

  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((mod) => mod.DashboardModule)
  },


  {
    path: 'orders',
    loadChildren: () =>
      import('./orders/orders.module').then((mod) => mod.OrdersModule)
  },

  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then((mod) => mod.SettingsModule)
  },

  {
    path: 'reports',
    loadChildren: () =>
      import('./reports/reports.module').then((mod) => mod.ReportsModule)
  },


  {
    path: 'products',
    loadChildren: () => import('./products/products.module').then((mod) => mod.ProductsModule)
  },


  // {
  //   path: '',
  //   loadChildren: () =>
  //     import('./products/products.module').then((mod) => mod.ProductsModule),
  //   data: { breadcrumb: 'Products' },
  // },

  // {
  //   path: 'products',
  //   loadChildren: () =>
  //     import('./products/products.module').then((mod) => mod.ProductsModule),
  //   data: { breadcrumb: 'Admin' },
  // },




  { path: '**', redirectTo: 'not-found', pathMatch: 'full' },
];

@NgModule({
  //imports: [RouterModule.forRoot(routes)],
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })], // Enable scroll position restoration

  exports: [RouterModule],
})
export class AppRoutingModule {}
